import React from "react";
import styled from "styled-components";
import moment from "moment";
import Accordion from "components/accordion";

const ListWrapper = styled.div`
    display: flex;
    background: #fafbfd;
    flex-direction: column;
    gap: 16px;
    padding: 40px;
`;

const ItemWrapper = styled.div`
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 38px;
        bottom: -38px;
        left: 24px; /* align with circle center (48px / 2) */
        border-left: 2px dashed #d3dae6;
    }

    &:last-child::before {
        display: none;
    }
`;

const ContentBox = styled.div`
    margin-left: 88px; /* 48px circle width + 40px desired gap */
    background: #fff;
    border-radius: 8px;
    padding: 37px 24px;
`;

const IndexCircle = styled.div`
    position: absolute;
    left: 0;
    top: 24px;
    width: 48px;
    height: 48px;
    display: flex;
    font-size: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    background: ${(props) => (props.skipped ? "#6B7280" : "#29586A")};
    font-weight: 700;
    z-index: 1;
`;

const TimesRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-top: 32px;

    .label {
        color: #374151;
        font-weight: 400;
        margin-inline-end: 6px;
        font-size: 16px;
    }

    .time {
        color: #374151;
        font-weight: 600;
        margin-right: 18px;
        font-size: 20px;
    }
`;

const SkippedPoint = styled.span`
    background-color: #6b7280;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    border-radius: 8px;
    padding: 8px 28px;
    margin-left: 38px;
`;

function formatTime(value) {
    if (!value) return "-";
    return moment(value).format("h:mm A");
}

export default function ActualPlan({ plan = [] }) {
    return (
        <ListWrapper>
            {plan.map((point, index) => {
                const title =
                    point?.locationAttributes?.nameAr || point?.locationAttributes?.name || "-";
                const formattedArrival = formatTime(point.arrivalTime);
                const formattedDeparture = formatTime(point.departureTime);
                const key = String(point.actualPosition ?? index);

                return (
                    <ItemWrapper key={key}>
                        <IndexCircle skipped={point.skipped}>
                            {point.skipped ? "-" : index + 1}
                        </IndexCircle>
                        <ContentBox skipped={point.skipped}>
                            {point.skipped ? (
                                <div
                                    style={{
                                        color: "#29586A",
                                        fontSize: "32px",
                                        fontWeight: "400",
                                    }}
                                >
                                    {title}
                                    <SkippedPoint>Skipped point</SkippedPoint>
                                </div>
                            ) : (
                                <Accordion
                                    id={`actual-plan-${key}`}
                                    title={title}
                                    defaultExpanded={false}
                                    titleColor="#29586A"
                                    fontSize="32px"
                                    iconSize="32px"
                                    titleFontWeight="400"
                                    iconAtEnd
                                    backgroundColor="transparent"
                                    body={
                                        <TimesRow>
                                            <div>
                                                <span className="label">arrival manual :</span>
                                                <span className="time">{formattedArrival}</span>
                                            </div>
                                            <div>
                                                <span className="label">departure manual :</span>
                                                <span className="time">{formattedDeparture}</span>
                                            </div>
                                        </TimesRow>
                                    }
                                />
                            )}
                        </ContentBox>
                    </ItemWrapper>
                );
            })}
        </ListWrapper>
    );
}
